import React, { Component } from 'react'
import { Layer, Box, Text } from 'grommet';
import ButtonBlue from '../Utils/buttonBlue';
import { withRouter } from "react-router-dom";
import { logout } from '../Utils/Utility';

class ModalErrorTimeout extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
        this.confirmButton = this.confirmButton.bind(this);
    }
    confirmButton() {
        logout();
    }



    render() {

        return (
            <Layer
                flush={true}
                animate={true}
                style={{ width: '50%', height: '400px', 'z-index': '9999' }}
            >
                <Box
                    justify="center"
                    background='white'
                    align="center"
                    pad='large'
                    gap='small'
                >

                    <Box direction="row"
                        gap="medium"
                        pad='medium'
                        align="center">
                        <Box align='center' margin='medium' alignContent='center'>
                            <Box direction='row' alignSelf='center' >
                                <Text className='text-title-blue'  >Sessione scaduta</Text>
                            </Box>
                            <Box>
                                <Text > Clicca su "TORNA ALLA LOGIN" per accedere di nuovo al portale. </Text>
                            </Box>
                            <Box style={{ width: '60%' }} gap='medium' className='detail-text'>
                                <ButtonBlue buttonName='TORNA ALLA LOGIN' style={{ width: '100%' }} onClick={this.confirmButton} /></Box>
                        </Box>
                    </Box>

                </Box>
            </Layer >
        )
    }
}
export default ModalErrorTimeout = withRouter(ModalErrorTimeout);
